import css from './Mobile.module.scss'
import React from 'react'
import Skeleton from 'react-loading-skeleton'

import { TICKETSMS_COLORS_BLACK, TICKETSMS_COLORS_MEDIUMGREY } from 'utils/constants/colors'

export const MobileSkeleton: React.FC = () => {
  return (
    <div className={css.pagewithsubsections_voices_mobile_container}>
      <Skeleton
        className={css.selectSkeleton}
        baseColor={TICKETSMS_COLORS_BLACK}
        borderRadius={16}
        highlightColor={TICKETSMS_COLORS_MEDIUMGREY}
      />
    </div>
  )
}
